
export default {
  name: 'FooterLayout',
  data() {
    return {
      showPrivacy: false,
      showISMS: false,
      pdfUrl: 'https://etax.one.th/tempimg/Cookie-Policy-INET-e-Tax.pdf',
    }
  },
  methods: {
    fn_gotoHome() {
      this.$router.push('/')
    },
    fn_previewPdf() {
      window.open(this.pdfUrl, '_blank')
    },
  },
}
